export default "__VITE_ASSET__CfwzmNrv__"